import { useCallback, useMemo, useState } from "react";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";

/**
 * Manages Tracking Paging & Event Handlers for Carousel Paging & Arrow Controls
 */
export const useCarouselPaging = ({ data, id, pageSize }) => {
  const storePageEvent = useStorePageEvent();
  const [page, setPage] = useState(0);
  const [remaining, setRemaining] = useState(data.length - pageSize);

  // Prev Arrow Handler
  const onPrevArrowClick = useCallback(() => {
    setPage(page - 1);
    setRemaining(remaining + pageSize);
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.CAROUSEL_PREVIOUS, id);
  }, [id, page, pageSize, remaining, storePageEvent]);

  // Next Arrow Handler
  const onNextArrowClick = useCallback(() => {
    const newRemain = remaining - pageSize;

    setPage(page + 1);
    setRemaining(Math.max(newRemain, 0));
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.CAROUSEL_NEXT, id);
  }, [id, page, pageSize, remaining, storePageEvent]);

  return useMemo(
    () => ({
      onNextArrowClick,
      onPrevArrowClick,
      page,
      remaining,
    }),
    [onNextArrowClick, onPrevArrowClick, page, remaining],
  );
};
